export const voiceAgent = {
  header: {
    title: "Głosowy agent AI",
    subBefore: "Odbiera połączenia telefoniczne dzięki AI działającej w czasie rzeczywistym. Obejmuje",
    subEmphasis: "całe Twoje konto",
    active: "Aktywny",
    inactive: "Nieaktywny",
  },
  loading: "Wczytywanie konfiguracji…",
  errors: {
    load: "Nie udało się wczytać konfiguracji.",
    save: "Nie udało się zapisać. Spróbuj ponownie.",
  },
  phone: {
    title: "Numer telefonu",
    desc: "Numer, na który dzwonią goście. Dla Twojego konta tworzony jest dedykowany numer.",
    checking: "Sprawdzanie numeru…",
    pendingTitle: "Telefonia oczekuje na aktywację",
    pendingText: "Tworzenie numerów nie jest jeszcze włączone na tym koncie. Skontaktuj się z nami, a je uruchomimy.",
    activeCountry: "Aktywny · kraj {country}",
    provisioning: "Przydzielanie… (może potrwać kilka minut)",
    release: "Zwolnij",
    numberCountry: "Kraj numeru",
    searching: "Wyszukiwanie…",
    seeAvailable: "Zobacz dostępne",
    perMonth: "{cost}/mies.",
    getThis: "Weź ten numer",
    getOne: "Weź numer",
    confirmRelease: "Czy na pewno zwolnić ten numer? Przestanie odbierać połączenia.",
    errNoneInCountry: "W tym kraju nie ma teraz dostępnych numerów.",
    errTelnyxInactive: "Telefonia nie jest jeszcze aktywna na tym koncie.",
    errSearchFailed: "Nie udało się wyszukać numerów.",
    errTelnyxInactiveContact: "Telefonia nie jest jeszcze aktywna na tym koncie. Skontaktuj się z nami, a ją włączymy.",
    errNoNumbersNow: "Nie ma teraz dostępnych numerów.",
    errProvisionFailed: "Nie udało się uzyskać numeru.",
    errReleaseFailed: "Nie udało się zwolnić numeru.",
  },
  voiceLang: {
    title: "Głos i język",
    assistantVoice: "Głos asystenta",
    recommended: "(zalecany)",
    listenVoiceTitle: "Posłuchaj głosu {voice}",
    loading: "Wczytywanie…",
    stop: "Zatrzymaj",
    listen: "Posłuchaj",
    mainLanguage: "Język główny",
    extraLanguages: "Dodatkowe języki, którymi może mówić",
    useIdentityTitle: "Użyj tożsamości agenta czatu",
    useIdentityDesc: "Wykorzystuje ponownie imię, osobowość i ton ustawione już w Ustawieniach ogólnych.",
    voiceAssistantName: "Nazwa asystenta głosowego",
    namePlaceholder: "np. recepcja Málaga Centro Suites",
    greeting: "Powitanie po odebraniu",
    optional: "(opcjonalnie)",
    greetingPlaceholder: "Jeśli pole pozostanie puste, asystent przywita się automatycznie, podając swoją tożsamość.",
    errPlayback: "Nie udało się odtworzyć próbki.",
    errGenerate: "Nie udało się wygenerować próbki głosu. Spróbuj ponownie.",
  },
  languages: {
    es: "Hiszpański",
    en: "Angielski",
    fr: "Francuski",
    pt: "Portugalski",
    it: "Włoski",
    de: "Niemiecki",
    ar: "Arabski",
  },
  countries: {
    ES: "Hiszpania",
    US: "Stany Zjednoczone",
    GB: "Wielka Brytania",
    FR: "Francja",
    IT: "Włochy",
    DE: "Niemcy",
    PT: "Portugalia",
    CO: "Kolumbia",
    MX: "Meksyk",
  },
  days: {
    mon: "Pon",
    tue: "Wt",
    wed: "Śr",
    thu: "Czw",
    fri: "Pt",
    sat: "Sob",
    sun: "Nd",
  },
  listings: {
    title: "Obiekty, dla których odbiera",
    desc: "Wybierz, dla których obiektów agent głosowy odbiera połączenia.",
    all: "Wszystkie obiekty",
    some: "Tylko wybrane",
    scopeNoteBefore: "Odbiera dla",
    scopeNoteStrong: "wszystkich",
    scopeNoteAfter: "obiektów na koncie, w tym tych dodanych w przyszłości.",
    searchPlaceholder: "Szukaj obiektu…",
    selectAll: "Zaznacz wszystkie",
    clearAll: "Odznacz wszystkie",
    loadingListings: "Wczytywanie obiektów…",
    noListings: "To konto nie ma żadnych obiektów.",
    noMatches: "Brak wyników.",
    noneWarn: "Jeśli nie zaznaczysz żadnego, agent będzie odbierać dla wszystkich.",
    allDesc: "Łącznie z tymi dodanymi później.",
    someDesc: "Tylko te zaznaczone poniżej.",
    selectedShort: "{n} z {total}",
  },
  capabilities: {
    title: "Co potrafi",
    knowledgeTitle: "Skąd czerpie informacje",
    knowledgeDesc: "Wybierz, co asystent sprawdza, gdy ktoś pyta o ofertę.",
    messagesTitle: "Przyjmowanie wiadomości",
    messagesDesc: "Jeśli czegoś nie wie, przyjmuje wiadomość od gościa i powiadamia Cię o niej.",
    linksTitle: "Wysyłanie linków po rozmowie",
    linksDesc: "Po zakończeniu rozmowy wysyła przez WhatsApp przydatny link (do check-in lub rezerwacji), gdy ma to sens.",
    photosTitle: "Wysyłaj zdjęcia wyposażenia i udogodnień",
    photosDesc: "Jeśli dzwoniący zapyta o udogodnienie, które ma zdjęcia, agent wyśle je przez WhatsApp na numer, z którego dzwoni.",
  },
  doc: {
    title: "Dokument z informacjami",
    desc: "Wgraj plik PDF lub Word, a agent będzie mógł odpowiadać na podstawie jego treści.",
    dropTitle: "Wgraj dokument",
    dropHint: "PDF lub Word (.docx), do 15 MB",
    uploading: "Wgrywanie dokumentu…",
    replace: "Zastąp",
    remove: "Usuń",
    chars: "Odczytano {n} znaków",
    noText: "Ten dokument jest skanem: składa się z obrazów, więc nie da się odczytać tekstu. Wgraj plik z prawdziwym tekstem.",
    errType: "Plik musi być w formacie PDF lub Word (.docx).",
    errSize: "Plik nie może być większy niż 15 MB.",
    errUpload: "Nie udało się wgrać dokumentu. Spróbuj ponownie.",
    errRemove: "Nie udało się usunąć dokumentu. Spróbuj ponownie.",
    fuenteBase: "Baza wiedzy",
    fuenteBaseDesc: "Informacje o Twoich ofertach: check-in, udogodnienia, zasady i najczęstsze pytania.",
    fuenteDoc: "Twój dokument",
    fuenteDocDesc: "Wyłącznie plik PDF lub Word wgrany poniżej, razem z jego instrukcjami.",
    fuenteAmbas: "Oba źródła",
    fuenteAmbasDesc: "Najpierw dokument, a jeśli nie ma w nim odpowiedzi, informacje o ofercie.",
    verTexto: "Zobacz, co czyta asystent",
    abrirOriginal: "Otwórz dokument",
    previewTitle: "Co asystent czyta z Twojego dokumentu",
    previewSub: "To tekst wydobyty z pliku. Jeśli czegoś tu brakuje, asystent też tego nie wie.",
    previewVacio: "Z tego pliku nie udało się wydobyć żadnego tekstu.",
    cerrar: "Zamknij",
    noUsado: "Dokument jest wgrany, ale asystent teraz z niego nie korzysta: wybrano odpowiadanie wyłącznie na podstawie bazy wiedzy.",
    faltaDoc: "Wgraj dokument, aby móc wybrać go jako źródło.",
  },
  hours: {
    title: "Godziny obsługi",
    specific: "Określone godziny",
    closed: "Zamknięte",
    afterHours: "Poza godzinami obsługi",
    afterVoicemail: "Nagraj wiadomość głosową",
    afterMessage: "Odtwórz komunikat i rozłącz się",
    afterMessagePlaceholder: "Komunikat odtwarzany poza godzinami obsługi.",
  },
  recording: {
    title: "Nagrywanie i zgodność z przepisami",
    recordTitle: "Nagrywaj rozmowy",
    recordDesc: "Zapisuje dźwięk rozmów, aby można je było odsłuchać.",
    noticeTitle: "Informuj o nagrywaniu",
    noticeDesc: "Asystent informuje na początku, że rozmowa może być nagrywana (zalecane zgodnie z RODO).",
    transcribeTitle: "Transkrybuj rozmowy",
    transcribeDesc: "Tworzy tekst każdej rozmowy.",
    transcribeNeedsRecord: "Transkrypcje powstają z nagrania: przy wyłączonej opcji „Nagrywaj rozmowy” żadne nie powstaną.",
  },
  advanced: {
    title: "Zaawansowane",
    maxDuration: "Maksymalny czas trwania rozmowy",
    minutesOption: "{n} minut",
    aiEngine: "Silnik AI",
  },
  save: {
    saved: "Zapisano ✓",
    save: "Zapisz zmiany",
    dirty: "Masz niezapisane zmiany",
    clean: "Wszystko zapisane",
  },
  credits: {
    title: "Minuty rozmów",
    desc: "Minuty zawarte w każdym miesiącu zależnie od liczby obiektów. Gdy się skończą, możesz je doładować w dowolnej chwili.",
    loading: "Wczytywanie salda…",
    minutesLeft: "min dostępnych",
    recharge: "Doładuj",
    includedThisMonth: "Wykorzystano {used} z {total} min zawartych w tym miesiącu",
    purchased: "{min} min dokupionych",
    empty: "Minuty się skończyły. Doładuj je, aby nadal odbierać połączenia.",
    error: "Nie udało się wczytać salda.",
    modal: {
      title: "Doładuj minuty",
      sub: "Wybierz pakiet. To płatność jednorazowa, a minuty są dodawane do salda natychmiast.",
      pay: "Zapłać kartą",
      secure: "Bezpieczna płatność ze Stripe.",
      close: "Zamknij",
      error: "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
    },
  },
};
